import { initialize } from './../../../account/initialize/index';
import { AccountService } from './../../../account/core/services/AccountService';
import * as angular from "angular";
import * as numeral from "numeral";
import * as _ from "lodash";
import * as Papa from "papaparse";
import moment = require('moment');

export class DataviewPageComponent implements ng.IComponentOptions {
  public controller: any = DataviewController;
  public template: string = /*html*/`
  <div class="container-fluid padding-2">
  <breadcrumb tree="$ctrl.tree"></breadcrumb>
  <div class="loading" ng-show="$ctrl.loading">
    <i class="fa fa-fw fa-spinner fa-spin"></i>
  </div>
  <div class="card row" ng-show="$ctrl.data">
  <div class="col-sm-12">
  <div class="part">
    <div class="part-70">
    <h4 class="margin-bottom-0">{{$ctrl.data.display_name}}<a class="data-category" ng-show="$ctrl.data.category" ng-href="#/search?category={{$ctrl.data.category}}">{{$ctrl.data.category}}</a></h4>
    <h5>{{$ctrl.data.filename}}</h5>
    <p class="data-subcontent padding-left" ng-hide="!$ctrl.data.agency">by {{$ctrl.data.agency.display_name}}, {{$ctrl.data.agency.ministry.display_name}}</p>
    <p class="data-subcontent padding-left" ng-show="$ctrl.data.ministry&&!$ctrl.data.agency">by {{$ctrl.data.ministry.display_name}}</p>
    </div>
    <div class="part-30 f-column flex f-end">
      <div>
      <a class="btn btn-default" style="background-color: #9f9f9f;color:#FFF" href="#/dataset/{{$ctrl.data.dataset_id}}"><i class="fa fa-fw fa-hand-o-left"></i> Back</a>
      <a class="btn btn-default" style="background-color: #9f9f9f;color:#FFF" ng-click="$ctrl.back()"><i class="fa fa-fw fa-list"></i> Back to List</a>
      <a class="btn btn-default" style="background-color: #d6cb43;color:#FFF" ng-click="$ctrl.pivotShow = !$ctrl.pivotShow" ng-show="$ctrl.pivotInitialized"><i class="fa fa-fw fa-bar-chart"></i> Pivot & Chart</a>
      <a class="btn btn-default bg-color-yellow" style="color:#FFF" ng-class="{'inactive': !$ctrl.account.isLogin}" ng-href="{{$ctrl.base + '/download?datasetId='+$ctrl.data.dataset_id+'&resourceId='+$ctrl.data.resource_oid+'&token='+$ctrl.token}}"><i class="fa fa-download fa-fw"></i> Download</a>
      </div>
    </div>
    </div>
  </div>
  <div class="row" ng-show="$ctrl.pivotShow" style="margin-bottom: 16px">
    <div class="col-xs-12">
      <div class="b-top" style="padding: 4px 8px; background-color:#3e6990;color:#FFF;font-size: 18px"><i class="fa fa-fw fa-bar-chart" style="padding-right:4px"></i>Pivot & Chart<a ng-href="{{$ctrl.base + '/animation.gif'}}" target="_blank" class="pull-right" style="color:#FFF;text-decoration:underline"><i class="fa fa-fw fa-info" style="cursor:pointer;"></i>User Guide</a></div>
    </div>
    <div class="col-xs-12">
      <div id="pivot" class="b-top"></div>
    </div>
  </div>
  <div class="col-sm-12">
    <div class="b-top" style="padding: 4px 8px; background-color:#d4f5f5;font-size: 18px"><i class="fa fa-fw fa-table" style="padding-right:4px"></i>Data View</div>
    <div class="part b-top">
      <div class="part-70 b-right">
      <div class="input-icon" ng-hide="$ctrl.raw">
      <i class="fa fa-search fa-fw"></i>
      <input type="text" class="form-control" placeholder="Search in dataset" ng-model="$ctrl.search.text" ng-change="$ctrl.updateView()"/>
      <i class="fa fa-close fa-fw pointer" ng-show="$ctrl.search.text" ng-click="$ctrl.search.text='';$ctrl.loadData()"></i>
      </div></div>
      <div class="part-30 flex">
      <div class="data-subcontent margin-right" style="flex:1 1 0;"><span class="data-subtitle">File Type</span><br>{{$ctrl.data.filetype.substr(1)}}</div>
      <div class="data-subcontent margin-right" style="flex:1 1 0;" ng-show="$ctrl.data.filesize"><span class="data-subtitle">File Size</span><br><span ng-show="$ctrl.data.filesize>1000000">{{$ctrl.data.filesize/1000000 | number:1}}MB</span><span ng-hide="$ctrl.data.filesize>1000000">{{$ctrl.data.filesize/1000 | number:0}}kB</span></div>
      <div class="data-subcontent" style="flex:1 1 0;" ng-show="$ctrl.data.total"><span class="data-subtitle">Number of Rows</span><br>{{$ctrl.data.total}} rows</div>
      </div>
    </div>
  </div>
  <div class="col-sm-12 text-center text-warning" ng-hide="$ctrl.data.result||$ctrl.raw||$ctrl.loading">Sorry, this data can only be download. Please use another format for data exploration.</div>
  </div>
  <div ng-show="$ctrl.raw" ng-bind-html="$ctrl.rawResult" class="raw-table"></div>
  <div class="row" ng-hide="$ctrl.raw">
    <div ng-class="{'col-md-9':$ctrl.visual_show,'col-sm-12':!$ctrl.visual_show}">
      <div class="row">
        <div class="col-sm-12">
          <div ui-grid="$ctrl.gridOptions" class="grid" ui-grid-pinning ui-grid-infinite-scroll ui-grid-cellNav ui-grid-auto-resize ui-grid-resize-columns ng-class="{'h-328': $ctrl.chart_show}"></div>
          <div class="slider container container-fluid" ng-class="{open: $ctrl.viewData}">
          <div class="card row flex f-column">
            <div class="card-heading padding-left">View Row Data
            <div class="pull-right">
              <i class="fa fa-window-maximize fa-fw pointer" ng-click="$ctrl.maximize()"></i>
              <i class="fa fa-close fa-fw pointer" ng-click="$ctrl.viewData=false"></i>
            </div>
            </div>
            <div class="card-body" id="data-view">
              <div class="row margin-0 flex" ng-repeat="field in $ctrl.data.result.fields" ng-switch on="$index % 2">
                <div class="col-sm-6" ng-switch-when="0">
                  <div class="row b-bottom b-right margin-0 flex">
                    <div class="col-sm-6 padding bg-grey">{{$ctrl.data.result.fields[$index].id}}</div>
                    <div class="col-sm-6 padding">{{$ctrl.currentRecord[$ctrl.data.result.fields[$index].id]}}</div>
                  </div>
                </div>
                <div class="col-sm-6 flex" ng-switch-when="0">
                  <div class="row b-bottom b-right margin-0 flex-1">
                    <div class="col-sm-6 padding bg-grey">{{$ctrl.data.result.fields[$index+1].id}}</div>
                    <div class="col-sm-6 padding">{{$ctrl.currentRecord[$ctrl.data.result.fields[$index+1].id]}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer text-center">
              <a href="" class="btn btn-xs btn-default" ng-click="$ctrl.navigationRow('F')"><i class="fa fa-fw fa-backward"></i></a>
              <a href="" class="btn btn-xs btn-default" ng-click="$ctrl.navigationRow('-1')"><i class="fa fa-fw fa-caret-left"></i></a>
              <span style="font-size:12px">Viewing row {{$ctrl.currentRow+1}} of {{$ctrl.records.length}}</span>
              <a href="" class="btn btn-xs btn-default" ng-click="$ctrl.navigationRow('+1')"><i class="fa fa-fw fa-caret-right"></i></a>
              <a href="" class="btn btn-xs btn-default" ng-click="$ctrl.navigationRow('L')"><i class="fa fa-fw fa-forward"></i></a>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="text-center" ng-show="($ctrl.isInternal || $ctrl.isAdmin)&&$ctrl.canReload">Data not match or cannot view properly? <a ng-click="$ctrl.reloadData()">Try reload dataset?</a></div>
    `
}

interface IScope extends ng.IScope {
  filter: any;
  openView: Function;
  window: any;
  boolChangeClass: any;
}

export class DataviewController {
  public static $inject: Array<string> = ["AccountService","$http", "$stateParams", "$filter", "$timeout", "$scope", "$uibModal", "$anchorScroll", "$location"];
  public data: any;
  public records: any;
  public tree: Array<any>;
  public currentRecord: any;
  public viewData: boolean;
  public loading: boolean;
  public search: {text:string};
  public currentRow: number;
  public total: number;
  public currentIdx: number = 1;
  public resource_id: string;
  public gridOptions: any;
  public gridApi: any;
  public renderedRow: Array<any>;
  public columns: Array<any>;
  public visual_show: boolean;
  public chartSelected: {line: boolean, bar: boolean, bar_stack: boolean, column: boolean, column_stack: boolean, area: boolean, pie: boolean};
  public isDataSelectionCollapsed: boolean;
  public chart_show: boolean;
  public chart: {label: string, value: Array<string>}
  public myChartObject: any;
  public numberFields: Array<string>;
  public token: string;
  public base: string;
  public pivotShow: boolean;
  public raw: boolean;
  public rawResult: string;
  public isAdmin: boolean;
  public isInternal: boolean;
  public canReload: boolean;
  public pivotInitialized: boolean;

  constructor(public account: AccountService, private $http: ng.IHttpService, private $stateParams: any, private $filter: ng.IFilterService, public $timeout: ng.ITimeoutService, private $scope: IScope, private $uibModal: ng.ui.bootstrap.IModalService, private $anchorScroll: ng.IAnchorScrollService, private $location: ng.ILocationService) {
    this.resource_id = $stateParams.id;
    this.search = {text:""};
    this.token = account.token;
    this.$location = $location;
    this.base = BASE;
    account.$promise.then(() => {
      this.isAdmin = account.isAdmin
      this.isInternal = account.usertype === 'internal'
    })
    this.gridOptions = {
      enableInfiniteScroll: true,
      enableFiltering: false,
      enableColumnResizing: true,
      infiniteScrollDown: true,
      infiniteScrollRowsFromEnd: 10,
      onRegisterApi: (gridApi) => {
        gridApi.infiniteScroll.on.needLoadMoreData(null, () => this.loadMore());
        this.gridApi = gridApi;
        this.gridApi.grid.registerRowsProcessor($scope.filter, 200);
      }
    }
    this.loadData().then(() => {
      $timeout(() => {
        this.gridApi.infiniteScroll.resetScroll(false, true);
      })
    });
    $scope.openView = (grid, idx) => {
      this.openView(grid, idx);
    }
    $scope.filter = (renderableRows) =>  {
      if (this.search.text.length) {
        let matcher = new RegExp(this.search.text, 'i');
        _.each(renderableRows, (row) => {
          let match = false;
          _.each(row.entity, value => {
            if (value && value.toString().match(matcher) ){
              match = true;
            }
          })
          if ( !match ){
            row.visible = false;
          }
        })
        return renderableRows;
      }
      else {
        return renderableRows;
      }

    }
    this.visual_show = false;
    this.isDataSelectionCollapsed = true;
    google.charts.load('current', {packages: ['corechart', 'charteditor']})
  }
  public loadData() {
    this.loading = true;
    return this.$http.get(`${BASE}/api/dataview/${this.resource_id}?query=${this.search.text}`)
    .then((d: any) => {
      this.data = d.data;
      this.total = _.get(d, 'data.total', 0);
      this.records = _.get(d, 'data.result.records', []);
      this.tree = [
        {name: d.data.display_name, path: `#/dataset/${d.data.dataset_id}`},
        {name: "Data View", active: true}
      ];
      this.canReload = !d.data.lastReloadOn || moment().diff(moment(d.data.lastReloadOn), 'hours', true) >= 24
      if (!_.get(d, 'data.result', null) || _.get(d, 'data.unparsable', false)) {
        return this.$http.get(`${BASE}/api/rawdataview/${this.resource_id}`)
      }
      let column: Array<any> = _.map(d.data.result.fields, (f:any) => {
          return {name: f.id.replace("(", "").replace(")","").replace("'",""), width:100, cellTooltip: true, headerTooltip: true};
        });
      this.columns = _.map(d.data.result.fields, (d:any) => {
        return d.id;
      })
      this.initializePivot()
      _.pull(this.columns, '_id');
      column = _.reject(column, {name:'_id'});
      column.unshift({
        name: 'View',
        cellTemplate:'<button class="btn btn-link" ng-click="grid.appScope.openView(grid, rowRenderIndex)"><i class="fa fa-fw fa-eye"></i></button>',
        pinnedLeft:true,
        width: 45
      })
      this.gridOptions.columnDefs = column;
      this.records = this.cleanData(this.records);
      this.gridOptions.data = this.records;
      if (this.records && this.records.length) {
        this.numberFields = [];
        _.each(this.records[0], (record:any, key) => {
          if (_.isNumber(record)) {
            this.numberFields.push(key);
          }
          else if (_.toNumber(record)) {
            this.numberFields.push(key);
          }
          else if (record && record.endsWith("%")) {
            this.numberFields.push(key);
          }
          else if (_.isString(record) && _.isFinite(parseFloat(record.replace(',','')))) {
            this.numberFields.push(key);
          }
          else {
            let testNumber = numeral(record).value();
            if (testNumber && testNumber !== NaN) {
              this.numberFields.push(key);
            }
          }
        })
      }
    })
    .then((result:any) => {
      this.loading = false
      if (_.get(result, 'data', null)) {
        this.raw = true
        this.rawResult = result.data
        this.initializePivot()
      }
    })
    .catch(() => {
      this.loading = false;
    })
  }
  public $onInit() {
    this.$anchorScroll();
  }
  public initializePivot() {
    if (this.data.resource_id && !this.pivotInitialized) {
      let path
      if ((this.data.unparsable || this.raw) && this.data.filetype === '.csv') {
        path = `${BASE}/download?datasetId=${this.data.dataset_id}&resourceId=${this.data.resource_oid}&token=${this.token}`
      }
      else {
        path = `${BASE}/downloadCsv/?id=${this.data.resource_id}&preview=true&token=${this.token}`
      }
      const renderers = $.extend($.pivotUtilities.renderers, $.pivotUtilities.gchart_renderers);
      const _this = this
      Papa.parse(path, {
        download: true,
        skipEmptyLines: true,
        complete: function(parsed){
          _this.pivotInitialized = true
          $("#pivot").pivotUI(parsed.data, {
            renderers: renderers,
            rendererOptions: { gchart: {width: 800, height: 600} }
          });
        }
      });
    }
  }
  public loadMore() {
    this.loading = true;
    this.$http.get(`${BASE}/api/dataview/${this.resource_id}?page=${this.currentIdx + 1}&query=${this.search.text}`)
    .then((d:any) => {
      this.gridApi.infiniteScroll.saveScrollPercentage();
      this.loading = false;
      this.records = _.concat(this.records, this.cleanData(d.data.result.records));
      this.gridOptions.data = this.records;
      this.currentIdx++;
      this.gridApi.infiniteScroll.dataLoaded(false, this.total > this.currentIdx*100);
    })
    .catch(err => {
      this.gridApi.infiniteScroll.dataLoaded()
    })
  }
  public filter(renderableRows) {
    if (this.search.text.length) {
      let matcher = new RegExp(this.search.text);
      renderableRows.forEach( function( row ) {
      let match = false;
      this.columns.forEach(function( field ){
        if ( row.entity[field].match(matcher) ){
          match = true;
        }
      });
      if ( !match ){
        row.visible = false;
      }
    });
    return renderableRows;
    }
    else {
      return renderableRows;
    }

  }

  public openView(grid, idx) {
    this.currentRow = idx;
    this.renderedRow = grid.renderContainers.body.visibleRowCache
    this.currentRecord = this.renderedRow[idx].entity;
    this.viewData = true;
  }

  public maximize() {
    this.$uibModal.open({
      component: 'rowFocusModal',
      resolve: {
        records: () => {
          return this.currentRecord
        }
      }
    })
  }

  public navigationRow(type) {
    switch(type) {
      case "-1":
        if (this.currentRow > 0){
          this.currentRow--
          this.currentRecord = this.renderedRow[this.currentRow].entity;
        }
        break;
      case "+1":
        if (this.currentRow < this.records.length -1){
          this.currentRow++
          this.currentRecord = this.renderedRow[this.currentRow].entity;
        }
        break;
      case "F":
        this.currentRecord = this.renderedRow[0].entity;
        break;
      case "L":
        this.currentRecord = this.renderedRow[this.records.length - 1].entity;
        break;
    }
    angular.element(document.querySelector('#data-view'))[0].scrollTop = 0;
  }
  public updateView() {
    if (!this.search.text || this.search.text.length > 3) {
      this.loadData();
    }

  }
  public showVisual() {
    this.visual_show = !this.visual_show;
    this.gridApi.grid.refresh();
  }
  public selectChart(type) {
    _.each(this.chartSelected, (selected, key) => {
      if (key === type) {
        this.chartSelected[key] = true;
      }
      else {
        this.chartSelected[key] = false;
      }
    })
    let chartType = {
      'line': "LineChart",
      'column': "ColumnChart",
      'column_stack': "ColumnChart",
      'bar': "BarChart",
      'bar_stack': "BarChart",
      'area': "AreaChart",
      'pie': "PieChart"
    }
    this.myChartObject.type = chartType[type];
    this.isDataSelectionCollapsed = false;
    if (_.indexOf(['column_stack','bar_stack'],type) > -1)
      this.myChartObject.options.isStacked = true;
    else
      this.myChartObject.options.isStacked = false;
    this.updateChart();
  }
  public updateChart() {
    if (this.chart.label && this.chart.value[0]) {
      let data = this.gridApi.grid.renderContainers.body.visibleRowCache;
      this.myChartObject.options.vAxis = {
        title: this.chart.value[0]
      }
      this.myChartObject.options.hAxis = {
        title: this.chart.label
      }
      let isPercentage = false
      this.myChartObject.data = {
          cols: [
            {id: this.chart.label, label: this.chart.label, type: 'string'},
            ..._.map(this.chart.value, val => {
              return {id: val, label: val, type: "number"}
            })
          ],
          rows: _.map(data, (d:any)=> {
            return {c: [
              {v: d.entity[this.chart.label]},
              ..._.map(this.chart.value, val => {
                if (d.entity[val] && d.entity[val].endsWith('%')) {
                  isPercentage = true;
                  return {v: _.toNumber(_.trimEnd(d.entity[val],'%'))/100}
                }
                else
                  return {v: _.toNumber(d.entity[val])}
              })
            ]}
          })
      }
      let rows = _.groupBy(this.myChartObject.data.rows, "c[0].v");
      let aggregatedRows = _.map(rows, (value, key) => {
        let result;
        _.each(value, (val:any, k) => {
          if (k === 0) {
            result = value[0];
          }
          else {
            _.each(val.c, (v, p:any) => {
              if(p > 0) {
                result.c[p].v += v.v;
              }
            })
          }
        })
        return result;
      })
      this.myChartObject.data.rows = aggregatedRows;
      if (isPercentage) {
        this.myChartObject.options.vAxis.format = 'percent';
        this.myChartObject.options.hAxis.format = 'percent';
      }

      if (this.myChartObject.type === 'PieChart') {
        this.myChartObject.options.title = this.chart.value[0];
        this.myChartObject.options.legend = {position: 'right'};
      }
      else {
        this.myChartObject.options.title = "";
        this.myChartObject.options.legend = {position: 'top', maxLines: 3};
      }
      this.chart_show = true;
    }
  }

  public cleanData(data) {
    return _.map(data, (d:any) => {
      const dd:any = _.omit(d, ['_id']);
      return _.transform(dd, (res, v:any, k:any) => {
        if (!isNaN(v)) {
          v = parseFloat(v).toString()
        }
        k = k.toString();
        return res[k.replace("(","").replace(")","").replace("'","")] = v;
      }, {})
    })

  }

  public back() {
    const url = localStorage.getItem("lastPage")
    if (url) {
      this.$location.url(url)
    }
    else {
      this.$location.url('/search')
    }
  }

  public reloadData() {
    this.$http.get(`${BASE}/api/dataset/reload/${this.data.dataset_id}`)
    .then(() => {
      swal({
        title: "Success!",
        text: "You request has been submitted and queue for process. Please wait for 24 for another retry",
        type: "success"
      },
      d => {
        this.$timeout(() => {
          this.canReload = false
        })
      });
    })
    .catch(err => {
      if (_.get(err, 'data.code') === 301) {
        swal("Oops", "We can't find the resource, please contact administrator", "warning")
      }
      else if (_.get(err, 'data.code') === 302) {
        swal("Sorry", "You request has been submitted and queue for process. Please wait for 24 for another retry", "warning")
      }
      else {
        swal("Oops", "Something went wrong, please try again", "warning")
      }
    })
  }
}
